<nav class="subnav">
  <ul class="nav">
    <li class="nav-item"><a class="nav-link" routerLinkActive="active" [routerLink]="['/component/overview', true]">Übersicht</a></li>
    <li class="nav-item"><a class="nav-link" routerLinkActive="active" [routerLink]="['/component/assembly']">Baugruppen</a></li>
    <li class="nav-item"><a class="nav-link" routerLinkActive="active" [routerLink]="['/component//standard']">Normteile</a></li>
    <li class="nav-item"><a class="nav-link" routerLinkActive="active" [routerLink]="['/component/technology']">Verfahren</a></li>
    <li class="nav-item"><a class="nav-link" routerLinkActive="active" [routerLink]="['/component/passive', false]">Passive</a></li>
  </ul>
</nav>
